import React from 'react';

/**
 * 글 안의 URL 을 누를 수 있는 링크로 — 댓글 · 제출 요약 · 반려 사유 · 체크인 · 운영진 메시지 등.
 * http(s):// 와 www. 로 시작하는 것만. 끝에 붙은 마침표 · 쉼표 · 닫는 괄호는 링크에서 뺀다.
 * 새 탭으로 열고, 바깥 행(눌러서 이동하는 카드 등)의 클릭으로 번지지 않게 한다.
 */

const URL_RE = /(https?:\/\/[^\s<>"]+|www\.[^\s<>"]+)/gi;
const TRAIL_RE = /[.,;:!?'")\]}>]+$/;

/** 글을 [글, { url, href }, 글, …] 조각으로 */
export const splitLinks = (text) => {
  if (!text) return [];
  const out = [];
  let last = 0;
  text.replace(URL_RE, (match, _g, at) => {
    const url = match.replace(TRAIL_RE, '');
    if (!url) return match;
    if (at > last) out.push(text.slice(last, at));
    out.push({ url, href: /^https?:\/\//i.test(url) ? url : `https://${url}` });
    last = at + url.length;
    return match;
  });
  if (last < text.length) out.push(text.slice(last));
  return out;
};

export const LinkText = ({ url, href }) => (
  <a
    href={href}
    target='_blank'
    rel='noopener noreferrer'
    onClick={(e) => e.stopPropagation()}
    className='text-green-deep03 underline underline-offset-2 [overflow-wrap:anywhere] hover:text-green-deep04'
  >
    {url}
  </a>
);

const Linkify = ({ text }) =>
  splitLinks(typeof text === 'string' ? text : '').map((part, i) =>
    typeof part === 'string' ? (
      part
    ) : (
      // eslint-disable-next-line react/no-array-index-key
      <LinkText key={i} {...part} />
    ),
  );

export default Linkify;
